import { z } from 'zod';
import { priceCatalogSchema } from './priceCatalogsSchema';
import { baseSchema, baseObjectSchema } from '../baseSchemas';

export const pricePolicySchema = z.object({
  id: z.string(),
  pricingType: z.union([z.literal(0), z.literal(1)]),
  companyId: z.string(),
  isActive: z.boolean(),
  isFromManager: z.boolean(),
  deleted: z.boolean(),
});

export const priceCatalogOrderSchema = z.object({
  id: z.string(),
  name: z.string(),
  code: z.string(),
  pricingPolicyId: z.string(),
  pricingPolicy: pricePolicySchema.optional(),
  isActive: z.boolean(),
  isFromManager: z.boolean(),
  deleted: z.boolean(),
});

export const getPriceCatalogsOrderSchema = z.array(priceCatalogOrderSchema);

export type GetPriceCatalogsOrderResponse = z.infer<typeof getPriceCatalogsOrderSchema>;

export const priceCatalogOrderDetailSchema = z.object({
  id: z.string(),
  pricingPolicyCatalogOrderHeaderId: z.string(),
  priceCatalogId: z.string(),
  priceCatalog: priceCatalogSchema.optional(),
  sequence: z.number(),
  isActive: z.boolean(),
  isFromManager: z.boolean(),
  deleted: z.boolean(),
});

export const getPriceCatalogOrderDetailsSchema = z.array(priceCatalogOrderDetailSchema);

export const pricingPolicyMatrixSchema = z.object({
  id: z.string(),
  name: z.string(),
  code: z.string(),
  pricingPolicyId: z.string(),
  pricingPolicy: pricePolicySchema.optional(),
  pricingPolicyCatalogOrderHeaderId: z.string(),
  pricingPolicyCatalogOrderHeader: priceCatalogOrderSchema.optional(),
  isActive: z.boolean(),
  isFromManager: z.boolean(),
  deleted: z.boolean(),
});

export const getPricingPolicyMatricesSchema = z.array(pricingPolicyMatrixSchema);

export type GetPricingPolicyMatricesResponse = z.infer<typeof getPricingPolicyMatricesSchema>;

export const getPricingPolicyMatrixDetailsSchema = z.array(
  baseObjectSchema.extend({
    pricingPolicyDetailMatrixHeaderId: z.string(),
    pricingPolicyDetailMatrixHeader: pricingPolicyMatrixSchema.optional(),
    traderSiteGroupId: z.string().optional(),
    traderSiteGroup: z
      .object({
        id: z.string(),
        name: z.string().optional(),
        address: z.string().optional(),
        city: z.string().optional(),
        zipCode: z.string().optional(),
      })
      .optional(),
    traderSiteId: z.string().optional(),
    traderSite: baseSchema.optional(),
    materialGroupId: z.string().optional(),
    materialGroup: baseSchema.optional(),
    materialId: z.string().optional(),
    material: baseSchema.optional(),
    discountType: z.union([z.literal(0), z.literal(1)]),
    value: z.number(),
    discountSequence: z.number(),
  })
);

export type GetPricingPolicyMatrixDetailsResponse = z.infer<
  typeof getPricingPolicyMatrixDetailsSchema
>;
